import React from "react";
import GlobalStyles from "styles/GlobalStyles";
import ComponentRenderer from "ComponentRenderer.js";
import HotelTravelLandingPage from "./demos/HotelTravelLandingPage";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Profile from "./pages/Profile/Profile";
import Detail from "./pages/Details";
import AllList from "./pages/AllList";
import ScrollToTop from "./pages/ScrollToTop";

import TermsOfService from "pages/TermsOfService";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

export default function App() {
  return (
    <>
      <GlobalStyles />
      <Router>
        <ScrollToTop>
          <Routes>
            <Route
              path="/components/:type/:subtype/:name"
              element={<ComponentRenderer />}
            />
            <Route
              path="/components/:type/:name"
              element={<ComponentRenderer />}
            />
            <Route path="/" element={<HotelTravelLandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/all-list" element={<AllList />} />
            <Route path="/all-list/:id" element={<Detail />} />
            <Route path="/terms" element={<TermsOfService />} />
          </Routes>
        </ScrollToTop>
      </Router>
    </>
  );
}
